<template>
    <main-content>
        <kt-panel class="mb-2">
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#limited_users">
                                {{ $t('security.limited_users') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#disabled_security_settings">
                                {{ $t('security.disabled_settings.tab') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
        </kt-panel>
        <div class="tab-content">
            <div class="tab-pane active" id="limited_users">
                <user-limited-filter :action="applyFilter"></user-limited-filter>
                <kt-datatable v-bind="datatableProps" ref="datatable">
                </kt-datatable>
            </div>
            <div class="tab-pane" id="disabled_security_settings">
                <disabled-security-settings></disabled-security-settings>
            </div>
        </div>
    </main-content>
</template>

<script>
import MainContent from "@/components/main-content.vue";
import { ApiUrl } from "@/common/api.service";
import { AuthorizationHeader } from "@/common/jwt.service";
import userLimitedColumn from "@/views/user/datatable/userLimitedColumn";
import UserLimitedFilter from "@/views/user/components/user-limited-filter.vue";
import DisabledSecuritySettings from "@/views/user/components/disabled-security-settings.vue";

export default {
    name: "UserLimited",
    components: { UserLimitedFilter, MainContent, DisabledSecuritySettings },
    data() {
        return {
            query: {},
        }
    },
    computed: {
        datatableProps() {
            return {
                id: 'fraud-event',
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('users/limited'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },

                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: userLimitedColumn
            }
        },
    },


    methods: {
        applyFilter(e, query) {
            this.query = query;
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },

        reloadDatatable() {
            if (this.$refs.datatable) {
                this.$refs.datatable.reload();
            }
        },
    }
}
</script>

<style scoped></style>